import React, { useEffect, useState } from 'react'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'
import { toast, ToastContainer } from 'react-toastify'
import styled from "styled-components";
import { Tabs } from '../../../../Components/elements/Tabs'
import { Generator } from './Generator'
import { DOCUMENT_TYPE, ECONOMIC_ACTIVITY, EXHIBIT_FILE, GENERATOR, GUIDEFILE } from '../../Utils/residuo-url'
import { PHONE_TYPE } from '../../Utils/residuo-url'
import { Representatives } from './Representatives'
import { WasteManagement } from './WasteManagement'
import { normalizePhone } from '../../../../Utils/normalize'
import { getRequest, loadSessionUser, postRequest } from '../../../../Services/axios.service'
import Modal from '../../../../Components/elements/modals/Modal'
import StarRatings from 'react-star-ratings'
import { SERVICE_CLIENT } from '../../../../Utils/url.api'
import { FaFacebookF, FaTwitter, FaYoutube } from 'react-icons/fa'
import { RiInstagramFill } from 'react-icons/ri'
// import useUser from '../../../../Context/hook/useUser'
import {useNavigate } from 'react-router-dom';
import { api_url } from '../../../../Utils/constants.api';

export const Registro = () => {

    const methods = useForm({
        mode: 'onBlur'
    })

    const branchOffices = useFieldArray({
        control: methods.control,
        name: 'sucursales',
    })

    const CerrarModal = () => {
        methods.reset();
        setOpen(false)
    }

    // const { getUser } = useUser()
    const navigate = useNavigate()
    const [open, setOpen] = useState(false)
    const [termsModal, setTermsModal] = useState(false)
    const [formattedValue, setFormattedValue] = useState(null)
    const [createdGenerator, setCreatedGenerator] = useState(null)
    const [calificacion, setCalificacion] = useState(0);
    const [options, setOptions] = useState(
        { documentTypes: [], phoneTypes: [], activities: [] }
    )
    const [loadingSet, setLoadingSet] = useState(
        { submitLoading: false }
    )
    const [check, onCheck] = useState(false)

    const guideRoute = `${api_url}/${GUIDEFILE}` 

    useEffect(() => {
        getData()

        return () => {
            methods.unregister()
        }
    }, [])

    const getData = async () => {
        fetchDocumentType()
        fetchPhoneType()
        fetchEconomicActivity()
    }

    const fetchDocumentType = async () => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        const params = new URLSearchParams([['fields', 'description,id,identificador']])
        const response = await getRequest(DOCUMENT_TYPE, { params, headers })
        const { success, statusCode, data } = response.data
        if (statusCode == 200 && success) {
            setOptions((cur) => ({ ...cur, documentTypes: data }))
        }
    }

    const fetchPhoneType = async () => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        const params = new URLSearchParams([['fields', 'description,id,identificador']])
        const response = await getRequest(PHONE_TYPE, { params, headers })
        const { success, statusCode, data } = response.data
        if (statusCode == 200 && success) {
            setOptions((cur) => ({ ...cur, phoneTypes: data }))
        }
    }

    const fetchEconomicActivity = async () => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        const params = new URLSearchParams([['fields', 'nombre,id,identificador']])
        setLoadingSet((cur) => ({ ...cur, activity: true }))
        const response = await getRequest(ECONOMIC_ACTIVITY, { params, headers })
        setLoadingSet((cur) => ({ ...cur, activity: false }))
        const { success, statusCode, data } = response.data
        if (statusCode == 200 && success) {
            setOptions((cur) => ({ ...cur, activities: data }))
        }
    }

    const onSubmit = (formData) => {
        const { exhibits, ...formatted } = {
            ...formData,
            numeroDocumento: formData?.numeroDocumento.replace(/-/g, ""),
            telefono: normalizePhone(formData?.telefono).toString(),
            generatorRepresentative: mapGeneratorRepresentative(formData.generatorRepresentative?.[0]),
            generadorPrestadorServicios: formData.generadorPrestadorServicios.map(g => normalizeEntities(g)),
            generadorResiduos: formData.generadorResiduos.filter(g => g.cantidad > 0),
            economicActivityGenerators: mapEconomicActivities(formData.economicActivityGenerators, formData.economicActivityDescripcion),
            sucursales: formData?.sucursales?.map(v => ({ ...v, sucursalResiduos: v.sucursalResiduos?.filter(s => s.cantidad > 0) }))
            // exhibits: formData.exhibits.filter(e => e?.file)

        }
        setFormattedValue(() => formatted)
        setTermsModal(() => true)
    }

    const onError = (errors, e) => {
        toast(`Verifique que todos los campos requeridos del formulario hayan sido completados`, {
          theme: "colored",
          type: "warning",
        });
      }

    const checkHandler = () => {
        onCheck((e) => !e)
    }

    const normalizeEntities = (value) => {
        const copy = { ...value }
        return { ...copy, numeroDocumento: copy.numeroDocumento.replace(/-/g, ""), telefono: normalizePhone(copy.telefono).toString() }
    }

    const mapEconomicActivities = (value, description) => {
        return value.map(v => ({ ...v, id: 0, generadorId: 0, descripcion: options.activities.find(s => s.id === v.actividadEconomicaId && s?.identificador === "OTROS") ? description : null }))
    }

    const mapGeneratorRepresentative = (value) => {
        return [
            {
                ...value,
                generadorId: 0,
                numeroDocumento: value.numeroDocumento.replace(/-/g, ""),
                telefonoGeneradorRepresentantes:
                    value?.telefonoGeneradorRepresentantes
                        ?.filter((x) => x.phoneTypeId && x.numeroTelefono)
                        .map((t) => ({
                            ...t,
                            id: 0,
                            numeroTelefono: normalizePhone(t?.numeroTelefono).toString(),
                            generatorRepresentativeId: 0,
                        })),
            },
        ];
    };

    const postGenerator = async (formValue) => {
        setTermsModal(false)
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        setLoadingSet((cur) => ({ ...cur, submitLoading: true }));
        toast.promise(postRequest(GENERATOR, formValue, { headers }), {
            pending: {
                position: "top-center",
                type: "default",
                isLoading: true,
                icon: false,
                render: () => "Espere",
            },
        })
            .then(({ data }) => {
                setLoadingSet((cur) => ({ ...cur, submitLoading: false }));
                if (data.statusCode === 201) {
                    toast.success("¡Generador Agregado con Éxito!")
                    // saveFiles(exhibits, data.data?.id)
                    setCreatedGenerator(cur => data.data)
                    setOpen(cur => true)
                } else if (data.statusCode === 500) {
                    toast(`Ha ocurrido un error, mensaje: ${data.message}`, {
                        theme: "colored",
                        type: "error",
                    });
                }
                else if (data.statusCode === 400) {
                    const message = data.message.split("\n Mensaje de respuesta")
                    toast(`Ha ocurrido un error, mensaje: ${message[0]}`, {
                        theme: "colored",
                        type: "error",
                    });
                }
            }).finally(() => setLoadingSet((cur) => ({ ...cur, submitLoading: false })));
    }

    const saveFiles = (files, generadorId) => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
            "Content-Type": "multipart/form-data"
        };
        const filePromise = files.map((file) => {
            const formData = new FormData()
            formData.append('file', file.file)
            const params = new URLSearchParams([['generadorId', generadorId], ['tipoAnexoId', file.tipoAnexoId]])
            return toast.promise(postRequest(EXHIBIT_FILE, formData, { headers, params }), {
                pending: {
                    position: 'top-center',
                    type: "default",
                    isLoading: true,
                    theme: 'colored',
                    closeOnClick: false,
                    render: () =>
                        <div className="text-xl font-semibold">
                            <span>...Guardando archivo {file.name}</span>
                            <div className="spinner-loading"></div>
                        </div>
                },
                error: {
                    position: 'top-center',
                    isLoading: true,
                    theme: 'colored',
                    closeOnClick: false,
                    render: `Ocurrio un error tratando de guardar el archivo ${file.name}`
                }
            })
        })
        setLoadingSet((cur) => ({ ...cur, submitLoading: true }));
        Promise.all(filePromise)
            .then((responses) => {
                responses.map(({ data }) => {
                    if (data.statusCode == 200 && data.success)
                        toast.success(`Archivo ${data.data.nombre} Guardado con éxito`, { position: 'top-right', autoClose: 2000 })
                    else {
                        toast.error(`Ocurrio un error tratando de guardar el archivo`, { position: 'top-right' })
                    }
                })
            })
            .catch((reason) => setLoadingSet((cur) => ({ ...cur, submitLoading: false })))
            .finally(() => setLoadingSet((cur) => ({ ...cur, submitLoading: false })))
    }


    const TermsModal = ({name, document}) => (
        <Modal estado={termsModal} >
            <Contenido>
                <h3 className="text-2xl mb-4 mt-2 text-left"><b>Finalizar Registro</b></h3>
                <p className="text-xl mb-6">
                    Está a punto de finalizar su solicitud de registro como generador de residuos de manejo especial y/o peligroso.
                </p>
                <h2
                    id="parent-modal-title"
                    className="text-primary font-semibold text-3xl text-center my-4"
                >
                    Declaración de responsabilidad sobre la información ingresada.
                </h2>
                <span className="text-justify">
                Yo, <b>{name}</b> con Razón social y/o cédula de identidad No. <span>{document}</span> {" "}
                declaro total responsabilidad por el uso del portal Web del Ministerio de Medio Ambiente y Recursos Naturales y por la veracidad de la información suministradas en los formularios de VUSA. La información suministrada podrá estar sujeta a verificación por parte de las autoridades ambientales correspondientes. La responsabilidad del usuario se extiende al uso de las claves de acceso suministradas e implica su consentimiento expreso de que la información suministrada quede incorporada en la base de datos propiedad del Ministerio de Medio Ambiente y Recursos Naturales.
                </span>

                <div className="mt-8 mb-4 flex flex-row items-center justify-end">
                    <input
                        onChange={checkHandler}
                        type={"checkbox"}
                        checked={check}
                        className="w-[15vw] h-[3vh] tab-port:w-[3vw] tab-port:h-[3vh] "
                    />
                    <p className="text-xl text-justify">
                        Acepto las condiciones generales aquí reflejadas
                    </p>
                </div>
                <p className="text-right text-lg text-font-muted">Para finalizar la solicitud, haga clic en el botón finalizar</p>
                <div className="flex justify-end gap-x-4">
                    <button 
                        className="py-4 px-8 text-2xl bg-font-muted text-white rounded-lg"
                        onClick={() => { setTermsModal(() => false) }}>
                        Atrás
                    </button>
                    <button disabled={!check} 
                        className="py-4 px-8 text-2xl bg-[#003670] text-white rounded-lg disabled:bg-font-disabled"
                        onClick={() => { postGenerator(formattedValue) }}>
                        Finalizar
                    </button>
                </div>
            </Contenido>
        </Modal>
    )

    const ReviewModal = () => (
        <Modal estado={open}>
            <Contenido>
                <h2
                    id="parent-modal-title"
                    className="text-primary font-semibold text-4xl"
                >
                    ¡Registro completado con exito!
                </h2>
                <div className="border border-bd-light p-4 mt-4">
                    <p
                        id="parent-modal-description"
                        className="text-xl my-6"
                    >
                        <b>Estimado (a) usuario (a)</b>, atendiendo a su solicitud se emite el número de código de generador de residuos de manejo especial y/o peligroso.
                    </p>
                    <div className="text-dark font-medium text-2xl text-center my-6 mx-8 py-4 border-2 border-bd-dark">
                        {createdGenerator?.numeroUnicoRegistro}
                    </div>
                    <p className="text-xl">
                    Puede proceder a la elaboración del plan de manejo de residuos de manejo especial y peligroso tal como establece los arts. 152, 153 y 154 de la ley 225-20 y los arts. 22, 23 y 24 del reglamento de aplicación el plazo establecido para depositar el plan de manejo será hasta el 30/03/2024.
                    </p>

                    <a className="my-2 link" href={guideRoute} target="_blank">
                        Descargar GUIA PARA LA ELABORACION DEL PLAN DE MANEJO DE LOS GENERADORES DE LOS RESIDUOS DE MANEJO ESPECIAL
                    </a>
                </div>
                    <div className="Contenedor-boton block">
                        <button className="py-6 px-32 text-4xl bg-[#003670] text-white rounded-lg" onClick={() => CerrarModal() }>
                            Aceptar
                        </button>
                    </div>
                <div className="footer__trademark-social text-primary-dark p-20 text-2xl ">
                    <span>SÍGUENOS</span>
                    <ul className="footer__trademark-social-list">
                        <li className="footer__trademark-social-item">
                            <i>
                                <a href="https://www.facebook.com/AmbienteRD/">
                                    <FaFacebookF />
                                </a>
                            </i>
                        </li>
                        <li className="footer__trademark-social-item">
                            <i>
                                <a href="https://twitter.com/ambienterd">
                                    <FaTwitter />
                                </a>
                            </i>
                        </li>
                        <li className="footer__trademark-social-item">
                            <i>
                                <a href="https://www.instagram.com/ambienterd/">
                                    <RiInstagramFill />
                                </a>
                            </i>
                        </li>
                        <li className="footer__trademark-social-item">
                            <i>
                                <a href="https://www.youtube.com/c/ministerioambienterd">
                                    <FaYoutube />
                                </a>
                            </i>
                        </li>
                    </ul>
                </div>
            </Contenido>
        </Modal>
    );

    return (
        <div className="phone:mx-0 tab-land:mx-20 small-desktop:mx-40 my-12">
            <ToastContainer />
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
                    <Tabs>
                        <div title="Datos Generador">
                            <Generator documentTypes={options.documentTypes} phoneTypes={options.phoneTypes} activities={options.activities} branchOffices={branchOffices} />
                        </div>
                        <div title="Datos Representantes y Prestadores">
                            <Representatives documentTypes={options.documentTypes} phoneTypes={options.phoneTypes} />
                        </div>
                        <div title="Datos Manejo de Residuos">
                            <WasteManagement branchOffices={branchOffices} />
                        </div>
                    </Tabs>
                    <div className="flex justify-end my-4  mr-4">
                        <button
                            type="submit"
                            disabled={loadingSet.submitLoading}
                            className="flex justify-center py-4 px-32 text-2xl bg-[#003670] text-white rounded-lg"
                        >
                            <span className="mr-4">Enviar</span>{" "}
                            {loadingSet.submitLoading && (
                                <div className="spinner-loading"></div>
                            )}
                        </button>
                    </div>
                </form>
                <TermsModal name={methods.getValues("nombre")} document={methods.getValues("numeroDocumento")} />
            </FormProvider>
            <ReviewModal />
        </div>
        
    )
}

const Contenido = styled.div`
  display: flex;
  flex-direction: column;

`;

const boxStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70vw",
    maxHeight: "90vh",
    bgcolor: "#fff",
    boxShadow: 20,
    overflow: 'auto',
};

